export default "__VITE_ASSET__BPCDbTkt__"